/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './equipment-ip-charges.reducer';

export const EquipmentIPChargesDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const equipmentIPChargesEntity = useAppSelector(state => state.equipmentIPCharges.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="equipmentIPChargesDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.equipmentIPCharges.detail.title">EquipmentIPCharges</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.equipmentIPCharges.id">Id</Translate>
            </span>
          </dt>
          <dd>{equipmentIPChargesEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.equipmentIPCharges.active">Active</Translate>
            </span>
          </dt>
          <dd>{equipmentIPChargesEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.equipmentIPCharges.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{equipmentIPChargesEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.equipmentIPCharges.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{equipmentIPChargesEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.equipmentIPCharges.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{equipmentIPChargesEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.equipmentIPCharges.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{equipmentIPChargesEntity.timestampEntry}</dd>
          <dt>
            <span id="price">
              <Translate contentKey="tinyMedicRestApp.equipmentIPCharges.price">Price</Translate>
            </span>
          </dt>
          <dd>{equipmentIPChargesEntity.price}</dd>
          <dt>
            <span id="maxDiscount">
              <Translate contentKey="tinyMedicRestApp.equipmentIPCharges.maxDiscount">Max Discount</Translate>
            </span>
          </dt>
          <dd>{equipmentIPChargesEntity.maxDiscount}</dd>
          <dt>
            <span id="chargeType">
              <Translate contentKey="tinyMedicRestApp.equipmentIPCharges.chargeType">Charge Type</Translate>
            </span>
          </dt>
          <dd>{equipmentIPChargesEntity.chargeType}</dd>
          <dt>
            <span id="multiplierApplied">
              <Translate contentKey="tinyMedicRestApp.equipmentIPCharges.multiplierApplied">Multiplier Applied</Translate>
            </span>
          </dt>
          <dd>{equipmentIPChargesEntity.multiplierApplied ? 'true' : 'false'}</dd>
          <dt>
            <span id="startDate">
              <Translate contentKey="tinyMedicRestApp.equipmentIPCharges.startDate">Start Date</Translate>
            </span>
          </dt>
          <dd>{equipmentIPChargesEntity.startDate}</dd>
          <dt>
            <span id="endDate">
              <Translate contentKey="tinyMedicRestApp.equipmentIPCharges.endDate">End Date</Translate>
            </span>
          </dt>
          <dd>{equipmentIPChargesEntity.endDate}</dd>
          <dt>
            <span id="suspended">
              <Translate contentKey="tinyMedicRestApp.equipmentIPCharges.suspended">Suspended</Translate>
            </span>
          </dt>
          <dd>{equipmentIPChargesEntity.suspended ? 'true' : 'false'}</dd>
          <dt>
            <span id="draft">
              <Translate contentKey="tinyMedicRestApp.equipmentIPCharges.draft">Draft</Translate>
            </span>
          </dt>
          <dd>{equipmentIPChargesEntity.draft ? 'true' : 'false'}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.equipmentIPCharges.equipment">Equipment</Translate>
          </dt>
          <dd>{equipmentIPChargesEntity.equipment ? equipmentIPChargesEntity.equipment.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.equipmentIPCharges.scheme">Scheme</Translate>
          </dt>
          <dd>{equipmentIPChargesEntity.scheme ? equipmentIPChargesEntity.scheme.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/equipment-ip-charges" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/equipment-ip-charges/${equipmentIPChargesEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default EquipmentIPChargesDetail;
